import { collection, addDoc, getDocs, query, where, updateDoc, deleteDoc } from 'firebase/firestore';
import { ref, listAll, deleteObject } from 'firebase/storage';
import { db, storage } from '../firebase/firebaseConfig';
import { sampleGirls } from '../data/sampleGirls';

// ฟังก์ชันสำหรับเพิ่มข้อมูลตัวอย่างน้องๆ เข้า Firestore
export const addSampleGirls = async () => {
  try {
    // ตรวจสอบว่ามีข้อมูลอยู่แล้วหรือไม่
    const girlsRef = collection(db, 'girls');
    const q = query(girlsRef, where('status', '==', 'available'));
    const existingGirls = await getDocs(q);
    
    if (existingGirls.docs.length > 0) {
      alert('มีข้อมูลน้องๆ อยู่แล้วในระบบ! ไม่จำเป็นต้องเพิ่มข้อมูลซ้ำ');
      return;
    }

    // เพิ่มข้อมูลตัวอย่างทีละคน
    const promises = sampleGirls.map(async (girl) => {
      try {
        await addDoc(girlsRef, {
          ...girl,
          createdAt: new Date(),
          updatedAt: new Date()
        });
        console.log(`✅ เพิ่มข้อมูล ${girl.nickname} สำเร็จ`);
      } catch (error) {
        console.error(`❌ ไม่สามารถเพิ่มข้อมูล ${girl.nickname}:`, error);
      }
    });

    await Promise.all(promises);
    
    alert('เพิ่มข้อมูลตัวอย่างน้องๆ สำเร็จ! รีเฟรชหน้าเว็บเพื่อดูผลลัพธ์');
    console.log('✅ เพิ่มข้อมูลตัวอย่างทั้งหมดสำเร็จ');
    
  } catch (error) {
    console.error('❌ ไม่สามารถเพิ่มข้อมูลตัวอย่าง:', error);
    alert('เกิดข้อผิดพลาด: ' + error.message);
  }
};

// ฟังก์ชันสำหรับอัพเดทข้อมูลน้องๆ ให้มีฟิลด์ใหม่
export const updateGirlsWithNewFields = async () => {
  try {
    const girlsRef = collection(db, 'girls');
    const snapshot = await getDocs(girlsRef);
    
    const promises = snapshot.docs.map(async (doc) => {
      const data = doc.data();
      
      // เพิ่มฟิลด์ใหม่ถ้าไม่มี
      const updateData = {};
      
      if (!data.subscription) {
        updateData.subscription = 'free';
      }
      
      if (!data.description) {
        updateData.description = data.bio || 'น้องน่ารัก บริการดี';
      }
      
      if (!data.momoName) {
        updateData.momoName = 'มอมจอย';
      }
      
      if (Object.keys(updateData).length > 0) {
        await updateDoc(doc.ref, {
          ...updateData,
          updatedAt: new Date()
        });
        console.log(`✅ อัพเดทข้อมูล ${data.nickname} สำเร็จ`);
      }
    });
    
    await Promise.all(promises);
    
    alert('อัพเดทข้อมูลน้องๆ สำเร็จ! รีเฟรชหน้าเว็บเพื่อดูผลลัพธ์');
    console.log('✅ อัพเดทข้อมูลทั้งหมดสำเร็จ');
    
  } catch (error) {
    console.error('❌ ไม่สามารถอัพเดทข้อมูล:', error);
    alert('เกิดข้อผิดพลาด: ' + error.message);
  }
};

// ฟังก์ชันสำหรับอัพเดทข้อมูลน้องๆ ให้มี subscription plan ตามข้อมูลจริง
export const updateGirlsWithSubscriptionPlans = async () => {
  try {
    const girlsRef = collection(db, 'girls');
    const snapshot = await getDocs(girlsRef);
    
    const promises = snapshot.docs.map(async (doc) => {
      const data = doc.data();
      
      // อัพเดท subscription plan ตามชื่อ
      let updateData = {};
      
      if (data.nickname === 'เอ๊ะ ดีแต่ปาก') {
        updateData = {
          subscription: 'premium',
          description: 'เล่นได้ ดื่มเก่ง',
          bio: 'เล่นได้ ดื่มเก่ง',
          momoName: 'มอมจอย'
        };
      } else if (data.nickname === 'ฝ้าย น่างับ') {
        updateData = {
          subscription: 'premium',
          description: 'สาวน่ารัก หน้าตาดี บริการดีมาก มีประสบการณ์',
          momoName: 'มอมแอม'
        };
      } else if (data.nickname === 'น้องใหม่') {
        updateData = {
          subscription: 'vip',
          description: 'สาวแกร่ง ใจดี มีความมั่นใจสูง บริการดีเยี่ยม',
          momoName: 'มอมซี'
        };
      } else {
        // สำหรับน้องอื่นๆ ที่ไม่ตรงกับข้อมูลจริง
        updateData = {
          subscription: data.subscription || 'free',
          description: data.description || data.bio || 'น้องน่ารัก บริการดี',
          momoName: data.momoName || 'มอมจอย'
        };
      }
      
      if (Object.keys(updateData).length > 0) {
        await updateDoc(doc.ref, {
          ...updateData,
          updatedAt: new Date()
        });
        console.log(`✅ อัพเดทข้อมูล ${data.nickname} สำเร็จ: subscription = ${updateData.subscription}`);
      }
    });
    
    await Promise.all(promises);
    
    alert('อัพเดทข้อมูลน้องๆ ด้วย Subscription Plans สำเร็จ! รีเฟรชหน้าเว็บเพื่อดูผลลัพธ์');
    console.log('✅ อัพเดทข้อมูลทั้งหมดสำเร็จ');
    
  } catch (error) {
    console.error('❌ ไม่สามารถอัพเดทข้อมูล:', error);
    alert('เกิดข้อผิดพลาด: ' + error.message);
  }
};

// ฟังก์ชันสำหรับล้างข้อมูลทั้งหมด (สำหรับ development)
export const clearAllGirls = async () => {
  try {
    const girlsRef = collection(db, 'girls');
    const snapshot = await getDocs(girlsRef);
    
    const promises = snapshot.docs.map(doc => deleteDoc(doc.ref));
    await Promise.all(promises);
    
    console.log('✅ ล้างข้อมูลทั้งหมดสำเร็จ');
    alert('ล้างข้อมูลทั้งหมดสำเร็จ!');
  } catch (error) {
    console.error('❌ ไม่สามารถล้างข้อมูล:', error);
    alert('เกิดข้อผิดพลาด: ' + error.message);
  }
};

// ฟังก์ชันสำหรับลบข้อมูลทั้งหมดของระบบ (เก็บไว้เฉพาะ subscription plans)
export const clearAllSystemData = async () => {
  try {
    // รายการ collections ที่จะลบ
    const collectionsToDelete = [
      'girls',
      'bookings', 
      'users',
      'imageViews',
      'imageApprovals',
      'tripPlans',
      'coinTransactions',
      'revenue',
      'notifications',
      'teamRequests',
      'roleRequests'
    ];
    
    let totalDeleted = 0;
    let totalImagesDeleted = 0;
    
    // ลบข้อมูลจากแต่ละ collection
    for (const collectionName of collectionsToDelete) {
      try {
        const collectionRef = collection(db, collectionName);
        const snapshot = await getDocs(collectionRef);
        
        if (snapshot.docs.length > 0) {
          const promises = snapshot.docs.map(doc => deleteDoc(doc.ref));
          await Promise.all(promises);
          totalDeleted += snapshot.docs.length;
          console.log(`✅ ลบข้อมูลจาก ${collectionName}: ${snapshot.docs.length} รายการ`);
        } else {
          console.log(`ℹ️ ไม่มีข้อมูลใน ${collectionName}`);
        }
      } catch (error) {
        console.error(`❌ ไม่สามารถลบข้อมูลจาก ${collectionName}:`, error);
      }
    }
    
    // ลบรูปภาพใน Firebase Storage
    try {
      console.log('🖼️ เริ่มลบรูปภาพใน Storage...');
      
      // ลบรูปภาพในโฟลเดอร์ girls
      const girlsImagesRef = ref(storage, 'girls');
      const girlsImagesList = await listAll(girlsImagesRef);
      
      for (const folderRef of girlsImagesList.prefixes) {
        const folderImages = await listAll(folderRef);
        for (const imageRef of folderImages.items) {
          try {
            await deleteObject(imageRef);
            totalImagesDeleted++;
            console.log(`✅ ลบรูปภาพ: ${imageRef.fullPath}`);
          } catch (error) {
            console.error(`❌ ไม่สามารถลบรูปภาพ ${imageRef.fullPath}:`, error);
          }
        }
      }
      
      // ลบรูปภาพในโฟลเดอร์อื่นๆ
      const otherFolders = ['profile-images', 'thumbnails', 'approved-images'];
      for (const folderName of otherFolders) {
        try {
          const folderRef = ref(storage, folderName);
          const folderImages = await listAll(folderRef);
          
          for (const imageRef of folderImages.items) {
            try {
              await deleteObject(imageRef);
              totalImagesDeleted++;
              console.log(`✅ ลบรูปภาพ: ${imageRef.fullPath}`);
            } catch (error) {
              console.error(`❌ ไม่สามารถลบรูปภาพ ${imageRef.fullPath}:`, error);
            }
          }
        } catch (error) {
          console.log(`ℹ️ ไม่มีโฟลเดอร์ ${folderName} หรือไม่มีรูปภาพ`);
        }
      }
      
      console.log(`✅ ลบรูปภาพใน Storage สำเร็จ: ${totalImagesDeleted} รูป`);
      
    } catch (error) {
      console.error('❌ ไม่สามารถลบรูปภาพใน Storage:', error);
    }
    
    console.log(`✅ ลบข้อมูลระบบทั้งหมดสำเร็จ: ${totalDeleted} รายการ, ${totalImagesDeleted} รูปภาพ`);
    alert(`ลบข้อมูลระบบทั้งหมดสำเร็จ!\n\nลบไปแล้ว:\n• ข้อมูล: ${totalDeleted} รายการ\n• รูปภาพ: ${totalImagesDeleted} รูป\n\nเก็บไว้: Subscription Plans เท่านั้น`);
    
  } catch (error) {
    console.error('❌ ไม่สามารถลบข้อมูลระบบ:', error);
    alert('เกิดข้อผิดพลาด: ' + error.message);
  }
};

// ฟังก์ชันสำหรับตรวจสอบสถานะ Firestore
export const checkFirestoreStatus = async () => {
  try {
    const girlsRef = collection(db, 'girls');
    const snapshot = await getDocs(girlsRef);
    
    console.log(`📊 จำนวนข้อมูลทั้งหมด: ${snapshot.docs.length}`);
    console.log('📋 รายการข้อมูล:', snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })));
    
    return {
      total: snapshot.docs.length,
      docs: snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    };
  } catch (error) {
    console.error('❌ ไม่สามารถตรวจสอบสถานะ Firestore:', error);
    return { total: 0, docs: [], error: error.message };
  }
};

/**
 * อัปเดตข้อมูลเก่าให้รองรับระบบราคาใหม่
 * @returns {Promise<void>}
 */
export const updateOldDataToNewPricing = async () => {
  try {
    const girlsRef = collection(db, 'girls');
    const snapshot = await getDocs(girlsRef);
    
    const updatePromises = snapshot.docs.map(async (docSnapshot) => {
      const girlData = docSnapshot.data();
      
      // ตรวจสอบว่ามีข้อมูลราคาใหม่แล้วหรือไม่
      if (girlData.servicePrice && girlData.coinPrice) {
        console.log(`✅ ${girlData.nickname} มีข้อมูลราคาใหม่แล้ว`);
        return;
      }
      
      // อัปเดตข้อมูลเก่า
      const updatedData = {
        ...girlData,
        // ตั้งราคาค่าบริการตามประเภท
        servicePrice: girlData.type === 'vn' ? 2500 : 
                     girlData.type === 'strong' ? 1800 : 1500,
        // ใช้ราคาเหรียญเดิม
        coinPrice: girlData.prices?.base || 50,
        // ตั้งค่าคอมมิชชั่นตามประเภท
        commission: girlData.type === 'vn' ? 0.35 : 
                    girlData.type === 'strong' ? 0.32 : 0.3,
        // อัปเดต prices object
        prices: {
          ...girlData.prices,
          base: girlData.prices?.base || 50,
          servicePrice: girlData.type === 'vn' ? 2500 : 
                       girlData.type === 'strong' ? 1800 : 1500,
          coinPrice: girlData.prices?.base || 50
        },
        updatedAt: new Date()
      };
      
      await updateDoc(docSnapshot.ref, updatedData);
      console.log(`✅ อัปเดตข้อมูล ${girlData.nickname} สำเร็จ`);
    });
    
    await Promise.all(updatePromises);
    console.log('✅ อัปเดตข้อมูลเก่าทั้งหมดสำเร็จ');
    alert('อัปเดตข้อมูลเก่าให้รองรับระบบราคาใหม่สำเร็จ! รีเฟรชหน้าเว็บเพื่อดูผลลัพธ์');
    
  } catch (error) {
    console.error('❌ ไม่สามารถอัปเดตข้อมูลเก่า:', error);
    alert('เกิดข้อผิดพลาด: ' + error.message);
  }
};

